<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    fill="#ffffff"
    d="M277.328 405.32V188.347l70.25 70.25 30.167-30.167-121.75-121.75-121.74 121.75 30.167 30.167 70.24-70.248V405.32z"
  />
</svg>
